var _path, _path2, _path3, _mask, _rect, _mask2, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 107,
    viewBox: "0 0 255 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.81 0.052002C249.701 0.052002 254.476 4.81642 254.476 10.6936C254.476 16.5708 249.701 21.3352 243.81 21.3352H182.857C188.748 21.3352 193.524 26.0997 193.524 31.9769C193.524 37.8541 188.748 42.6185 182.857 42.6185H216.381C222.272 42.6185 227.048 47.3829 227.048 53.2601C227.048 59.1373 222.272 63.9017 216.381 63.9017H200.878C193.45 63.9017 187.429 68.6661 187.429 74.5433C187.429 78.4615 190.476 82.0087 196.571 85.1849C202.462 85.1849 207.238 89.9494 207.238 95.8266C207.238 101.704 202.462 106.468 196.571 106.468H70.0952C64.2042 106.468 59.4286 101.704 59.4286 95.8266C59.4286 89.9494 64.2042 85.1849 70.0952 85.1849H10.6667C4.77563 85.1849 0 80.4205 0 74.5433C0 68.6661 4.77563 63.9017 10.6667 63.9017H71.619C77.5101 63.9017 82.2857 59.1373 82.2857 53.2601C82.2857 47.3829 77.5101 42.6185 71.619 42.6185H33.5238C27.6328 42.6185 22.8571 37.8541 22.8571 31.9769C22.8571 26.0997 27.6328 21.3352 33.5238 21.3352H94.4762C88.5852 21.3352 83.8095 16.5708 83.8095 10.6936C83.8095 4.81642 88.5852 0.052002 94.4762 0.052002H243.81ZM243.81 42.6185C249.701 42.6185 254.476 47.3829 254.476 53.2601C254.476 59.1373 249.701 63.9017 243.81 63.9017C237.918 63.9017 233.143 59.1373 233.143 53.2601C233.143 47.3829 237.918 42.6185 243.81 42.6185Z",
    fill: "#56BC2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.238 53.2601H206.857C211.276 53.2601 214.857 56.8418 214.857 61.2601V84.7861C214.857 89.2043 211.276 92.7861 206.857 92.7861H116.572M174.476 53.2601H65.905C61.4867 53.2601 57.905 56.8418 57.905 61.2601V84.7861C57.905 89.2043 61.4868 92.7861 65.905 92.7861H88.3812M109.714 92.7861H102.857M96.0001 92.7861H94.4763",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.476 53.2601L67.4287 53.2601C63.0105 53.2601 59.4287 49.6783 59.4287 45.2601L59.4287 21.734C59.4287 17.3158 63.0105 13.734 67.4287 13.734L157.714 13.7341M191.238 53.2601L208.381 53.2601C212.799 53.2601 216.381 49.6783 216.381 45.2601L216.381 21.7341C216.381 17.3158 212.799 13.7341 208.381 13.7341L185.905 13.7341M179.048 13.7341L172.191 13.7341L165.333 13.7341M182.857 53.2601L184.381 53.2601",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_2984_10969",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.2383,
    y: 66.9421,
    width: 54.8571,
    height: 13.6821,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.2383,
    y: 66.9421,
    width: 54.8571,
    height: 13.6821,
    rx: 2,
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "bevel",
    mask: "url(#path-4-inside-1_2984_10969)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_2984_10969",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.2383,
    y: 24.3757,
    width: 54.8571,
    height: 13.6821,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2383,
    y: 24.3757,
    width: 54.8571,
    height: 13.6821,
    rx: 2,
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "bevel",
    mask: "url(#path-5-inside-2_2984_10969)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.536,
    y: 68.1921,
    width: 11.2143,
    height: 11.1821,
    rx: 5.59104,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "bevel"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.536,
    y: 25.6257,
    width: 11.2143,
    height: 11.1821,
    rx: 5.59104,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "bevel"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 174.965,
    y: 68.1921,
    width: 11.2143,
    height: 11.1821,
    rx: 5.59104,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "bevel"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 174.965,
    y: 25.6257,
    width: 11.2143,
    height: 11.1821,
    rx: 5.59104,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.c30db8327738902dbe3e65bf8edd6a01.svg";
export { ForwardRef as ReactComponent };